export const Colors = {
  Disputable: '#2A51F6',
  DisputableText: '#F2F3F9',
  NonDisputable: '#EF817D',
  NonDisputableText: '#111529',
  HoverBackground: '#EBEEFF',
  Grid: '#CDD0E0',
  Line: '#E3E5EF',
  Text: '#676C89',
};
